export default __webpack_public_path__ + "static/figma-latest-designs-767eeb76291be6f52359a78affd3a7ed.svg";